﻿export function validate(file, maxsize, ...extensions) {
    if (file.size < 0) {
        return 'The selected file is empty';
    }
    if (JSON.stringify(extensions) === JSON.stringify(['.svg'])) {
        if (maxsize && file.size > maxsize * 1024) {
            return `We only allow a maximum size of ${maxsize}KB`;
        }
    } else if (maxsize && file.size > maxsize * 1048576) {
        return `We only allow a maximum size of ${maxsize}mb`;
    }

    if (extensions
        && extensions.filter((ext) => file.name.toLowerCase().endsWith(ext)).length !== 1) {
        return `We only accept ${extensions.join(', ')} files. The file uploaded was of type ${file.type}`;
    }

    return '';
}

export function uploadToS3(
    file,
    bucketpath,
    xamzcredential,
    xamzdate,
    policy,
    xamzsignature,
    callback,
) {
    const xhr = new XMLHttpRequest();
    const fd = new FormData();
    xhr.open('POST', 'https://s3.ap-southeast-2.amazonaws.com/giveeasy.org/', true);

    fd.append('key', bucketpath);
    fd.append('acl', 'public-read');
    fd.append('x-amz-credential', xamzcredential);
    fd.append('x-amz-algorithm', 'AWS4-HMAC-SHA256');
    fd.append('x-amz-date', xamzdate);
    fd.append('policy', policy);
    fd.append('x-amz-signature', xamzsignature);
    fd.append('file', file);

    // For now let's get the upload event once it finishes.
    // we can use this for validation and file previews.

    // We can use 'onProgress' event to get the upload progress
    // for fileupload progressbars/
    if (callback) {
        xhr.addEventListener('load', (e) => callback(e), false);
    }

    xhr.send(fd);
}
